import ProductTemplate from "../../Biscuits-Template/Template";
import BisImg from "../../../assets/products/waffers/chocolate waffer.png";
import BiscuitImg from "../../../assets/products/waffers/Chocolate-Waffer.png";
import { Helmet } from "react-helmet-async";

const BiscuitData = [
  {
    grams: 6,
  },
  {
    grams: 7,
  },
  {
    grams: 16,
  },
  {
    grams: 18,
  },
];

export default function ChocolateWafferProduct() {
  return (
    <>
      <Helmet>
        <title>Chocolate Waffer – BearBitz | Premium Wafers & Biscuits</title>
        <meta
          name="description"
          content="Explore BearBitz Chocolate Wafers — crispy, chocolate-filled wafer biscuits. View pack sizes, cartons, and global specs."
        />
        <meta
          name="keywords"
          content="Chocolate Waffer, BearBitz Chocolate Wafers"
        />
        <link
          rel="canonical"
          href="https://www.bearbitz.in/waffers/chocolatewaffer"
        />
        <meta property="og:title" content="Chocolate Waffer – BearBitz" />
        <meta
          property="og:description"
          content="Delicious chocolate wafer biscuit by BearBitz crafted for premium taste and export quality."
        />
      </Helmet>

      <ProductTemplate
        productTitle="CHOCOLATE"
        productImage={BisImg}
        description="Crisp Layers, Creamy Delight Light, crunchy wafer layers filled with smooth cream in flavors like vanilla, chocolate, strawberry, and more. These biscuits offer a perfect bite of crisp and cream, making them a favorite among kids and teens. Easy to pack, easy to love – ideal for export markets worldwide."
        tableData={BiscuitData}
        BiscuitLogo={BiscuitImg}
        textColor="#6A3E20"
        sectionBgColor="#FFC158"
        productBgcolor="#FFECCB"
        tableheadBgcolor="#6A3E20"
        tableBgcolor="#FFE7BE"
        footerBgcolor="#6A3E20"
      />
    </>
  );
}
